// extracted by mini-css-extract-plugin
module.exports = {"mainBlockContainer":"Main_mainBlockContainer__29CJs"};